import { required, Validator } from '@/entities/validation';
import { ChecklistTemplateEditable } from '@/ui/DTO';

export const validate: Validator<ChecklistTemplateEditable> = todo => [
  ...required(todo.title, 'title'),
];
